import React from 'react';
import { ChevronRightIcon } from '@heroicons/react/20/solid';
import { Link } from 'react-router-dom';
import { getBreadcrumbs, NavigationItem } from './navigation';

interface BreadcrumbsProps {
  items: NavigationItem[];
  pathname: string;
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items, pathname }) => {
  const breadcrumbs = getBreadcrumbs(items, pathname);
  if (!breadcrumbs.length) return null;

  return (
    <nav aria-label="Breadcrumb" className="min-w-0">
      <ol className="flex min-w-0 items-center overflow-hidden whitespace-nowrap text-sm text-slate-600 dark:text-slate-300">
        {breadcrumbs.map((breadcrumb, index) => {
          const current = index === breadcrumbs.length - 1;
          return (
            <li key={`${breadcrumb.label}-${index}`} className="flex min-w-0 items-center">
              {index > 0 && <ChevronRightIcon className="mx-2 h-4 w-4 shrink-0 text-slate-400" aria-hidden="true" />}
              {current ? (
                <span aria-current="page" className="truncate font-semibold text-slate-950 dark:text-white">
                  {breadcrumb.label}
                </span>
              ) : (
                <Link to={breadcrumb.href!} className="truncate hover:text-amber-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-club-gold-600 dark:hover:text-amber-300 dark:focus-visible:ring-club-gold-500">
                  {breadcrumb.label}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
